import { IconApi } from '@components/icons/api';
import { IconApplicants } from '@components/icons/applicants';
import { IconLock } from '@components/icons/lock';
import { IconNotifications } from '@components/icons/notifications';
import { isNotFalse } from '@utils/types';

import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

export const useProfileNavigationItems = () => {
  const { t, current } = useStore();
  const { hasRolePermission } = usePermissions();

  return [
    {
      icon: <IconApplicants />,
      path: '/profile/details',
      label: t('navigation.profile.profile'),
    },
    hasRolePermission('notifications:view') && {
      icon: <IconNotifications />,
      path: '/profile/notifications',
      label: t('navigation.profile.notifications'),
    },
    !current.info.useForceSso && {
      icon: <IconLock />,
      path: '/profile/security',
      label: t('navigation.profile.security'),
    },
    hasRolePermission('api:view') && {
      icon: <IconApi />,
      path: '/profile/api',
      label: t('navigation.profile.api'),
    },
  ].filter(isNotFalse);
};
